<template>
  <div v-if="worlds">
    <div v-if="chartActive == true">
      <ChartHistory />
    </div>
    <div v-else>
      <SelectSearchType />
      <div v-if="searchOption == 'world'" class="home">
        <SelectWorld />
        <SelectCategory />
        <ItemListByWorld />
      </div>
      <div v-else-if="searchOption == 'item'" class="home">
        <SearchItem />
        <ItemListByItem />
      </div>
      <div v-else-if="searchOption == 'transfer'" class="home">
        <SelectWorldsTransfer/>
        <ItemListByWorldTransfer/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import SelectWorld from "@/components/home/SelectWorld";
import ItemListByWorld from "@/components/home/ItemListByWorld";
import SelectCategory from "@/components/home/SelectCategory";
import SelectSearchType from "@/components/home/SelectSearchType";
import SearchItem from "@/components/home/SearchItem";
import ItemListByItem from "@/components/home/ItemListByItem";
import ChartHistory from "@/components/home/ChartHistory";
import SelectWorldsTransfer from "@/components/home/SelectWorldsTransfer"
import ItemListByWorldTransfer from "@/components/home/ItemListByWorldTransfer"

import { mapActions, mapState } from "vuex";

export default {
  name: "Home",
  components: {
    SelectWorld,
    ItemListByWorld,
    SelectCategory,
    SelectSearchType,
    SearchItem,
    ItemListByItem,
    ChartHistory,
    SelectWorldsTransfer,
    ItemListByWorldTransfer
  },
  async mounted() {
    try {
      await this.getItems();
      await this.getWorlds();
    } catch (error) {
      console.log(error);
      this.$router.go();
    }
  },
  computed: {
    ...mapState(["worlds", "searchOption", "chartActive"]),
  },
  methods: {
    ...mapActions(["getItems", "getWorlds"]),
    reload() {
      // this.$router.go();
    },
  },
};
</script>


